var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "flex" }, [
        _c(
          "div",
          { staticClass: "drug_select" },
          [
            _c("DrugSearch", {
              ref: "searchDrug",
              attrs: {
                searchType: _vm.searchType,
                selectedDrug: _vm.drug,
                onSelect: (d) => this.updateDrug(d),
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.drug && _vm.drug.id
          ? _c("div", { staticClass: "drug_line" }, [
              _c("div", { staticClass: "flex" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.qty,
                      expression: "qty",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "number" },
                  domProps: { value: _vm.qty },
                  on: {
                    change: _vm.updateQty,
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.qty = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _vm.drug && _vm.drug.cool
                  ? _c("div", { staticClass: "cool_mark" }, [
                      _c("i", { staticClass: "icon icon-snowflake" }),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.drug.id && _vm.getDiscountPrices()
                  ? _c("div", { staticClass: "cool_mark pointer" }, [
                      _c("i", {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: {
                              show: _vm.toolOpen,
                              placement: "bottom-center",
                              content: _vm.getDiscountPrices(true),
                              classes: "discount_tooltip tooltip_on_modal",
                            },
                            expression:
                              "{\n                    show: toolOpen,\n                    placement: 'bottom-center',\n                    content: getDiscountPrices(true),\n                    classes: 'discount_tooltip tooltip_on_modal'\n                  }",
                          },
                        ],
                        staticClass: "icon icon-fa icon-fa-percent",
                      }),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.drug && _vm.drug.id
                  ? _c(
                      "div",
                      [
                        _c(
                          "v-popover",
                          {
                            attrs: {
                              "auto-hide": true,
                              popoverClass: "tooltip_on_modal",
                            },
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-info btn-xs border-r-0",
                                staticStyle: { height: "38px" },
                                on: {
                                  click: function ($event) {
                                    return _vm.getDrugInfo()
                                  },
                                },
                              },
                              [_c("i", { staticClass: "icon-fa icon-fa-info" })]
                            ),
                            _vm._v(" "),
                            _c(
                              "template",
                              { slot: "popover" },
                              [
                                !_vm.drugInfoLoading
                                  ? [
                                      _vm.projectInfo[_vm.drug.id] &&
                                      _vm.projectInfo[_vm.drug.id][
                                        _vm.$editNewOrder.site_id
                                      ]
                                        ? _c(
                                            "div",
                                            [
                                              _c("div", {
                                                staticClass: "mb-1",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.printDrugInfo(
                                                      _vm.projectInfo[
                                                        _vm.drug.id
                                                      ][
                                                        _vm.$editNewOrder
                                                          .site_id
                                                      ]
                                                    )
                                                  ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              _vm.projectInfo[_vm.drug.id][
                                                _vm.$editNewOrder.site_id
                                              ].mirror_sources
                                                ? _vm._l(
                                                    _vm.projectInfo[
                                                      _vm.drug.id
                                                    ][_vm.$editNewOrder.site_id]
                                                      .mirror_sources,
                                                    function (source) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "mirror_source_data flex",
                                                        },
                                                        [
                                                          source.data.image
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "w-50 mr-1",
                                                                },
                                                                [
                                                                  _c("img", {
                                                                    attrs: {
                                                                      src: source
                                                                        .data
                                                                        .image,
                                                                      alt: "",
                                                                    },
                                                                  }),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c("div", [
                                                            _c("p", [
                                                              _vm._v(
                                                                "Данные на проекте: "
                                                              ),
                                                              _c("strong", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    source.title
                                                                  )
                                                                ),
                                                              ]),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("p", [
                                                              _vm._v(
                                                                "препарат: "
                                                              ),
                                                              _c(
                                                                "a",
                                                                {
                                                                  attrs: {
                                                                    href: `${
                                                                      source
                                                                        .data
                                                                        .link_share ??
                                                                      source
                                                                        .data
                                                                        .link
                                                                    }`,
                                                                    target:
                                                                      "_blank",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      source
                                                                        .data
                                                                        .title
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            source.data
                                                              .manufacturer
                                                              ? _c("p", [
                                                                  _vm._v(
                                                                    "производитель:\n                          "
                                                                  ),
                                                                  _c("strong", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        source
                                                                          .data
                                                                          .manufacturer
                                                                      )
                                                                    ),
                                                                  ]),
                                                                ])
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            source.data.country
                                                              ? _c("p", [
                                                                  _vm._v(
                                                                    "страна: "
                                                                  ),
                                                                  _c("strong", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        source
                                                                          .data
                                                                          .country
                                                                      )
                                                                    ),
                                                                  ]),
                                                                ])
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            source.data
                                                              .block_reason
                                                              ? _c("p", [
                                                                  _c("strong", [
                                                                    _vm._v(
                                                                      "препарат НЕ отображается\n                          (" +
                                                                        _vm._s(
                                                                          source
                                                                            .data
                                                                            .block_reason
                                                                        ) +
                                                                        ")"
                                                                    ),
                                                                  ]),
                                                                ])
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            source.data.price
                                                              ? _c("p", [
                                                                  _vm._v(
                                                                    "цена: "
                                                                  ),
                                                                  _c("strong", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        source
                                                                          .data
                                                                          .price
                                                                      )
                                                                    ),
                                                                  ]),
                                                                ])
                                                              : _vm._e(),
                                                          ]),
                                                        ]
                                                      )
                                                    }
                                                  )
                                                : _vm._e(),
                                            ],
                                            2
                                          )
                                        : _c("div", [
                                            _vm._v(
                                              "\n                  Нет данных\n                "
                                            ),
                                          ]),
                                    ]
                                  : [
                                      _vm._v(
                                        "\n                Загрузка ....\n              "
                                      ),
                                    ],
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "close-popover",
                                        rawName: "v-close-popover",
                                      },
                                    ],
                                    staticClass: "btn btn-theme btn-sm",
                                  },
                                  [
                                    _vm._v(
                                      "\n                Закрыть\n              "
                                    ),
                                  ]
                                ),
                              ],
                              2
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "price_details mt-1" },
                [
                  _c("OrderPriceLine", {
                    attrs: {
                      drug: _vm.drug,
                      divId: _vm.$editNewOrder.division_id,
                      discount: _vm.discount,
                      priceDisabled: _vm.projectPriceDisabled,
                      actualPrice: _vm.actualPrice,
                      updatePriceToActual: () => _vm.updatePriceToActual(),
                      priceForActualization: _vm.priceForActualization,
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex" }, [
        _c(
          "div",
          { staticClass: "drug_box_info" },
          [
            _vm.drug && (_vm.drug.pack_box_comment || _vm.drug.pack_comment)
              ? _c("div", { staticClass: "alert alert-info mb-0 mt-1 p-2" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.drug.pack_box_comment) +
                      "\n        "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.drug && _vm.drug.id && _vm.drugInfoRequest
              ? [
                  _c("DrugInfo", {
                    ref: "drugInfo",
                    attrs: {
                      drug: _vm.drug,
                      locality: _vm.$editNewOrder,
                      updateDrug: (d) => this.updateDrug(d, true),
                      updateTrigger: () =>
                        this.updateDeliveryDate && this.updateDeliveryDate(),
                    },
                  }),
                  _vm._v(" "),
                  _vm.$refs.drugInfo &&
                  +_vm.qty > +_vm.$refs.drugInfo.actualStoreQty
                    ? _c(
                        "div",
                        { staticClass: "mt-1" },
                        [
                          _c("DeliveryData", {
                            ref: "drugDeliveryData",
                            attrs: {
                              cityId: _vm.$editNewOrder.city_id,
                              updateDeliveryDate: _vm.updateDeliveryDate,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              : _vm._e(),
          ],
          2
        ),
        _vm._v(" "),
        _vm.drug?.id && _vm.drugPriceArranged
          ? _c("div", { staticClass: "mt-4 pt-2 ml-1" }, [
              _c("div", { staticClass: "alert alert-warning w-100 p-2" }, [
                _c("p", [_vm._v("Был заказан")]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.drugOutsourceData.drug.title))]),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.drugOutsourceData.drug.qty)),
                  ]),
                  _vm._v("уп. по "),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.drugOutsourceData.drug.price)),
                  ]),
                  _vm._v("р.\n          ("),
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm.drugOutsourceData.drug.qty *
                          _vm.drugOutsourceData.drug.price
                      )
                    ),
                  ]),
                  _vm._v("р)\n        "),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.drug?.id
        ? [
            _c(
              "div",
              { staticClass: "form-group mt-1 mb-1" },
              [
                _vm._m(0),
                _vm._v(" "),
                _vm._l(
                  _vm.drug?.extra_data?.comments ?? [],
                  function (comment, i) {
                    return comment.created_at
                      ? _c(
                          "div",
                          { staticClass: "drug_comment alert-warning" },
                          [
                            _c("p", { staticClass: "mb-0" }, [
                              _vm._v(_vm._s(comment.text)),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex flex_gap_10" },
                              [
                                _c("p", { staticClass: "mb-0 text-muted" }, [
                                  _vm._v(
                                    _vm._s(_vm.printDate(comment.created_at))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("LoadingButton", {
                                  attrs: {
                                    title:
                                      '<i class="icon-fa icon-fa-remove"/>',
                                    type: "button",
                                    loading: _vm.removeBtnLoading,
                                    color: _vm.$constants.WARNING_COLOR,
                                    onClick: () =>
                                      _vm.removeComment(_vm.drug.id, i),
                                    className: "btn btn-outline-warning btn-xs",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e()
                  }
                ),
                _vm._v(" "),
                !_vm.addNewComment
                  ? _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-info btn-xs",
                          attrs: { type: "button" },
                          on: { click: _vm.addComment },
                        },
                        [
                          _vm._v(
                            "добавить\n          комментарий к препарату\n        "
                          ),
                        ]
                      ),
                    ])
                  : _c("div", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.drug.extra_data.comments[
                                _vm.drug.extra_data.comments.length - 1
                              ].text,
                            expression:
                              "drug.extra_data.comments[drug.extra_data.comments.length - 1].text",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          placeholder:
                            "комментарий для кладовщика и курьера по препарату",
                        },
                        domProps: {
                          value:
                            _vm.drug.extra_data.comments[
                              _vm.drug.extra_data.comments.length - 1
                            ].text,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.drug.extra_data.comments[
                                _vm.drug.extra_data.comments.length - 1
                              ],
                              "text",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
              ],
              2
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "" } }, [
      _c("strong", [_vm._v("Комментарий к препарату (курьер/склад)")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }